export default {
    primary: '#01BFFF',
    secondary: '#fff',
    primaryText: '#000',
    secondaryText: '#696969',
    background: '#fff',
    label: '#222',
    border: '#b8b8b8',
    shadow: '#d2d0d071'
}